export enum AuthenticationType {
    None = 'None',
    Basic = 'Basic',
    Bearer = 'Bearer',
    ApiKey = 'ApiKey',
}
